/* eslint-disable no-restricted-syntax */
import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ReferralType } from 'types/types';
import { useAppContext } from '../../context/appContext';
import Icon from '../../components/Icon/Icon';

const REFERRAL_QUESTIONS: Array<{ type: string; questions: Partial<ReferralType> }> = [
  {
    type: 'Primary Care Referral',
    questions: {
      kindOfAppointment: 'What kind of appointment does **{insert patient name}** need?',
      notes: 'Add your referral notes or comments.',
    },
  },
  {
    type: 'Specialty Referral',
    questions: {
      specialtyType: 'Specialty Type',
      reason: 'Reason for Referral or Diagnosis',
      icdCode: 'ICD-10 Code',
      notes: 'Add your referral notes or comments',
    },
  },
  {
    type: 'Therapy Referral',
    questions: {
      reasonForTherapist: 'Why are you referring **{insert patient name}** to a therapist?',
      notes: 'Add your referral notes or comments',
    },
  },
  {
    type: 'Request Medical History',
    questions: {
      nameOfClinic:
        'What is the name of the clinic or provider you are requesting medical records from?',
      timeOfVisit: 'When did your patient see this provider or visit this clinic?',
      typeOfRecord: 'What type of records are you requesting?',
      describeRecord: 'Describe the type of medical records you are requesting',
      otherInformation: 'Anything else we should know?',
    },
  },
  {
    type: 'Other',
    questions: {
      notes: 'Add your notes or comments',
    },
  },
];

function ReferralDetails() {
  const [{ patients }] = useAppContext();
  const { visitId } = useParams<{ visitId: string }>();

  const navigate = useNavigate();

  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const patientId = params.get('patient');

  const patient = patients?.find(fndPatient => fndPatient.id === patientId);

  const { referral } = (location.state || {}) as {
    referral: ReferralType;
  };

  const questions = REFERRAL_QUESTIONS.find(fndReferral => fndReferral.type === referral.type)
    ?.questions as Record<string, string>;

  return (
    <div className="relative pt-8 tablet:pt-14 pb-14 flex flex-col justify-center items-center">
      <button
        onClick={() => navigate(-1)}
        type="button"
        className="absolute top-14 left-0 hidden tablet:flex flex-row items-center"
      >
        <Icon id="goBack" className="w-8 h-8" />
      </button>

      <div className="w-full tablet:w-[90%] laptop:w-[50%] text-center">
        <h2 className="font-semibold text-[20px] text-river-black">Referral Details</h2>
        <p className="text-sm mt-1 text-river-black">{referral.type}</p>
      </div>

      <div className="w-full tablet:w-[90%] laptop:w-[50%] mt-[40px] space-y-5">
        {questions &&
          Object.keys(questions).map((question, index) => (
            <div
              className="border border-[#C6D1D6] rounded-md px-5 tablet:px-7 pt-4 pb-5"
              key={index}
            >
              <h3 className="font-medium text-lg flex flex-row tablet:space-x-4 items-center leading-normal">
                <span
                  className="bg-black rounded-full w-7 h-7 items-center justify-center 
              text-white text-sm flex-shrink-0 hidden tablet:inline-flex"
                >
                  {index + 1}
                </span>
                <p>
                  {questions[question]?.replace(
                    /\*\*{insert patient name}\*\*/g,
                    `${patient?.firstName}`,
                  )}
                </p>
              </h3>
              <hr className="border-t-[1px] border-[#CFD8DD] my-3" />
              <div>{(referral as any)[question]}</div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default ReferralDetails;
